import React, { FC } from "react";
import { Link } from "react-router-dom";

export const Logo: FC = () => {
  return (
    <Link to="/">
      <svg width="130" viewBox="0 0 124.928 23.354">
        <defs>
          <clipPath id="prefix__a">
            <path
              fill="none"
              d="M0 0h124.928v18.54H0z"
              data-name="Rectangle 1"
            />
          </clipPath>
          <clipPath id="prefix__b">
            <path
              fill="none"
              d="M0 0h124.928v23.354H0z"
              data-name="Rectangle 2"
            />
          </clipPath>
        </defs>
        <g data-name="Group 11">
          <g data-name="Group 2">
            <g
              clipPath="url(#prefix__a)"
              data-name="Group 1"
              transform="translate(0 4.814)"
            >
              <path
                fill="#171716"
                d="M12.504 11.171H4.779a.6.6 0 01-.611-.579V4.056a.6.6 0 01.611-.58h7.725V.051H3.335A3.113 3.113 0 00.006 3.506v7.771a2.992 2.992 0 003.329 3.321h9.169z"
                data-name="Path 1"
              />
            </g>
          </g>
          <path
            fill="#da0017"
            d="M15.343 7.318l-4.9 4.841 4.9 4.841z"
            data-name="Path 2"
          />
          <g data-name="Group 4">
            <g fill="#171716" clipPath="url(#prefix__b)" data-name="Group 3">
              <path
                d="M71.636 4.846v3.43h-7.192a.646.646 0 00-.534.632c-.055.578.335.678.335.678l5.216 1.758s3.063.96 3.063 3.2v1.95a2.955 2.955 0 01-3.226 2.917h-8.98v-3.432h7.846a.725.725 0 00.728-.739c0-.63-.768-.857-.768-.857l-5.8-1.982s-2.048-.706-2.048-2.333V7.795a3.051 3.051 0 013.344-2.949z"
                data-name="Path 3"
              />
              <path
                d="M32.591 4.917h4.015V15.91h6.808v3.429h-10.82z"
                data-name="Path 4"
              />
              <path
                d="M74.078 4.917h11.745v3.578h-3.888l.006 10.842h-4.014V8.496h-3.848z"
                data-name="Path 5"
              />
            </g>
          </g>
          <g data-name="Group 6">
            <g
              fill="#171716"
              clipPath="url(#prefix__a)"
              data-name="Group 5"
              transform="translate(0 4.814)"
            >
              <path
                d="M88.085.103h4.006v14.421h-4.006z"
                data-name="Rectangle 3"
              />
              <path
                d="M98.435 3.825v6.906a.6.6 0 00.612.58h4.751a.6.6 0 00.609-.58V3.825a.6.6 0 00-.609-.58h-4.751a.6.6 0 00-.612.58m6.393-3.821a3.18 3.18 0 013.439 3.46v7.851a3.159 3.159 0 01-3.439 3.325h-6.84a3 3 0 01-3.329-3.325V3.463a3.115 3.115 0 013.329-3.46z"
                data-name="Path 6"
              />
              <path
                d="M121.838.102h-11.137v14.421h4.01V3.532h5.742a.6.6 0 01.613.582v10.41h3.857V3.566c0-3.74-3.089-3.464-3.089-3.464"
                data-name="Path 7"
              />
            </g>
          </g>
          <g data-name="Group 8">
            <g clipPath="url(#prefix__b)" data-name="Group 7">
              <path
                fill="#171716"
                d="M50.065 8.349h7.926V4.917h-11.03a1.594 1.594 0 00-1.48 1.481v11.465a1.589 1.589 0 001.48 1.478h11.032v-3.428h-7.928a.742.742 0 01-.724-.687V13.85h6.229v-3.252h-6.224V9.04a.741.741 0 01.724-.688"
                data-name="Path 8"
              />
            </g>
          </g>
          <g data-name="Group 10">
            <g
              clipPath="url(#prefix__a)"
              data-name="Group 9"
              transform="translate(0 4.814)"
            >
              <path
                fill="#171716"
                d="M21.991 3.535h7.93V.103H18.89a1.592 1.592 0 00-1.479 1.481v11.465a1.588 1.588 0 001.479 1.478h11.032v-3.429h-7.93a.742.742 0 01-.722-.687V9.035h6.227V5.786H21.27V4.225a.742.742 0 01.722-.688"
                data-name="Path 9"
              />
              <path
                fill="#fff"
                d="M12.504 39.457H4.779a.6.6 0 01-.611-.579v-6.536a.6.6 0 01.611-.58h7.725v-3.425H3.335a3.113 3.113 0 00-3.329 3.455v7.771a2.992 2.992 0 003.329 3.321h9.169z"
                data-name="Path 10"
              />
            </g>
          </g>
        </g>
      </svg>
    </Link>
  );
};
